// src/modules/feedbacks/components/FeedbackFilters.tsx
import React from 'react';
import { Card, Row, Col, Input, Select, Button, Space } from 'antd';
import { SearchOutlined, ReloadOutlined, FilterOutlined } from '@ant-design/icons';

const { Option } = Select;

interface FeedbackFiltersProps {
  filters: {
    rating?: number;
    is_approved: 'pending' | 'approved' | 'all';
    sort: 'newest' | 'oldest' | 'highest' | 'lowest';
    search: string;
  };
  loading: boolean;
  onFiltersChange: (filters: any) => void;
  onApply: () => void;
  onReset: () => void;
  onRefresh: () => void;
}

export const FeedbackFilters: React.FC<FeedbackFiltersProps> = ({
  filters,
  loading,
  onFiltersChange,
  onApply,
  onReset,
  onRefresh,
}) => {
  return (
    <Card className="mb-4">
      <Row gutter={[16, 16]}>
        <Col span={6}>
          <Input
            placeholder="Поиск по заказу, имени, телефону..."
            prefix={<SearchOutlined />}
            value={filters.search}
            onChange={(e) => onFiltersChange({ ...filters, search: e.target.value })}
            onPressEnter={onApply}
            allowClear
          />
        </Col>
        
        <Col span={4}>
          <Select
            placeholder="Оценка"
            style={{ width: '100%' }}
            value={filters.rating}
            onChange={(value) => onFiltersChange({ ...filters, rating: value })}
            allowClear
          >
            <Option value={3}>Отлично ⭐⭐⭐</Option>
            <Option value={2}>Хорошо ⭐⭐</Option>
            <Option value={1}>Плохо ⭐</Option>
          </Select>
        </Col>
        
        <Col span={4}>
          <Select
            placeholder="Статус модерации"
            style={{ width: '100%' }}
            value={filters.is_approved}
            onChange={(value) => onFiltersChange({ ...filters, is_approved: value })}
          >
            <Option value="pending">На модерации</Option>
            <Option value="approved">Одобренные</Option>
            <Option value="all">Все</Option>
          </Select>
        </Col>
        
        <Col span={4}>
          <Select
            placeholder="Сортировка"
            style={{ width: '100%' }}
            value={filters.sort}
            onChange={(value) => onFiltersChange({ ...filters, sort: value })}
          >
            <Option value="newest">Сначала новые</Option>
            <Option value="oldest">Сначала старые</Option>
            <Option value="highest">Высокая оценка</Option>
            <Option value="lowest">Низкая оценка</Option>
          </Select>
        </Col>
        
        <Col span={6}>
          <Space>
            <Button 
              type="primary" 
              icon={<FilterOutlined />}
              onClick={onApply}
              loading={loading}
            >
              Применить
            </Button>
            <Button onClick={onReset}>
              Сбросить
            </Button>
            <Button 
              icon={<ReloadOutlined />}
              onClick={onRefresh}
              loading={loading}
            />
          </Space>
        </Col>
      </Row>
    </Card>
  );
};